import * as firebase from "firebase";
import help from "@/store/fileManager/help.js";

export default {
    state: {
        folderStructure: [],
        activeFolder: {},
        folderBreadCrumbs: []
    },
    getters: {
        getFolderStructure(state) {
            return state.folderStructure;
        },
        getActiveFolder(state) {
            return state.activeFolder;
        },
        getFolderBreadCrumbs(state) {
            return state.folderBreadCrumbs;
        },
        getFilesAndBreadCrumbsForFolder: (state) => (folderId) => {
            const folderProps= help.getFolderProperties(state.folderStructure, folderId);
            const breadCrumbs = help.calculateFolderBreadCrumbs(state.folderStructure, folderProps.name, folderProps.path);
            return {
                files: folderProps.files,
                breadCrumbs: breadCrumbs
            }
        }
    },
    mutations: {
        setFolderStructure(state, payload) {
            state.folderStructure = payload;
        },
        setActiveFolder(state, payload) {
            state.activeFolder = payload;
        },
        setFolderBreadCrumbs(state, payload) {
            state.folderBreadCrumbs = payload;
        }
    },
    actions: {
        refreshFilemanager({state, dispatch}) {
            dispatch("fetchFileContainerFromDatabase");
            if (state.activeFolder.id) {
                dispatch("updateActiveFolder", state.activeFolder.id);
            }
        },
        fetchFileContainerFromDatabase({ commit }) {
            commit("setLoading", true);
            firebase.database().ref("fileContainer").once("value")
                .then((data) => {
                    let folderStructure = help.firebaseObjectToTreeview(data.val());
                    commit("setFolderStructure", folderStructure);
                    commit("setLoading", false);
                })
                .catch((error) => {
                    commit("setLoading", false);
                    commit("setErrorMessage", error.message);
                });
        },
        updateActiveFolder({ state, commit }, payload) {
            commit("setLoading", true);
            const activeFolderProps = help.getFolderProperties(state.folderStructure, payload);
            let activeFolder = {
                id: activeFolderProps.id,
                name: activeFolderProps.name,
                type: activeFolderProps.type,
                path: activeFolderProps.path,
                level: activeFolderProps.level,
                files: activeFolderProps.files
            }
            commit("setFolderBreadCrumbs", help.calculateFolderBreadCrumbs(state.folderStructure, activeFolder.name, activeFolder.path))
            commit("setActiveFolder", activeFolder);
            commit("setLoading", false);
        },
        createSubFolder({ state, commit, dispatch }, payload) {
            commit("setLoading", true);
            if (state.activeFolder === "") {
                commit("setLoading", false);
                commit("setErrorMessage", "Cannot create folder in root directory.");
                return;
            }
            if (help.ifFolderNameRepeated(state.folderStructure, payload, state.activeFolder.id)) {
                commit("setLoading", false);
                commit("setErrorMessage", "Cannot create two folders with same name in a folder.");
                return;
            }
            const parentFolderProps = help.getFolderProperties(state.folderStructure, state.activeFolder.id);
            const newFolderProps = {
                name: payload,
                type: "folder",
                path: parentFolderProps.path + parentFolderProps.id + "/children/",
                createdBy: "BUM6ogonoaSKNOdnxuUjiRfDoFt1",
                createdDate: new Date().toISOString(),
                level: parentFolderProps.level + 1
            }
            firebase.database().ref(newFolderProps.path).push(newFolderProps)
                .then(() => {
                    const successMessage = "Folder '" + newFolderProps.name + "' was created successfully.";
                    commit("setSuccessMessage", successMessage);
                    commit("setLoading", false);
                    dispatch("refreshFilemanager");
                })
                .catch((error) => {
                    commit("setErrorMessage", error.message);
                    commit("setLoading", false);

                })
        },
        deleteFolder({ state, commit, dispatch }) {
            commit("setLoading", true);
            const folderProps = help.getFolderProperties(state.folderStructure, state.activeFolder.id);
            if (folderProps.hasChildren || folderProps.hasFiles) {
                commit("setLoading", false);
                commit("setErrorMessage", "Cannot delete non-empty folder.");
            } else {
                firebase.database().ref(folderProps.path).child(folderProps.id).remove()
                    .then(() => {
                        commit("setLoading", false);
                        commit("setSuccessMessage", "Folder '" + folderProps.name + "' successfully deleted.");
                        dispatch("fetchFileContainerFromDatabase");
                        dispatch("clearActiveFolder");
                    })
                    .catch(error => {
                        commit("setLoading", false);
                        commit("setErrorMessage", error.message);
                    })
            }
        },
        clearActiveFolder({ commit }) {
            commit("setActiveFolder", {});
            commit("setFolderBreadCrumbs", []);
        },
        uploadNewFile({ state, commit, dispatch }, payload) {
            commit("setLoading", true);

            if(help.ifFileNameRepeated(state.folderStructure, payload.newFile.name, state.activeFolder.id)) {
                commit("setLoading", false);
                commit("setErrorMessage", "Cannot create two files with same name in a folder.");
                return;    
            }

            const parentFolderProps = help.getFolderProperties(state.folderStructure, state.activeFolder.id);
            let storagePath = "materials/";
            state.folderBreadCrumbs.forEach((item) => {
                if (item !== "") {
                    storagePath = storagePath + item + "/";
                }
            });
            let newFile = {
                name: payload.newFile.name.substr(0, payload.newFile.name.lastIndexOf('.')),
                ext: payload.newFile.name.substr(payload.newFile.name.lastIndexOf('.') + 1).toLowerCase(),
                type: "file",
                path: parentFolderProps.path + parentFolderProps.id + "/files/",
                createdBy: payload.userId,
                modifiedBy: payload.userId,
                createdDate: new Date().toISOString(),
                modifiedDate: new Date().toISOString(),
                level: parentFolderProps.level + 1,
                storagePath: storagePath + payload.newFile.name,
                description: payload.description,
                version: 1,
                displayName: payload.displayName,
                size: payload.newFile.size
            }
            firebase.storage().ref(newFile.storagePath).put(payload.newFile)
                .then(() => {
                    firebase.database().ref(newFile.path).push(newFile)
                        .then(() => {
                            const successMessage = "The file '" + newFile.name + "." + newFile.ext +"' was successfully uploaded.";
                            commit("setLoading", false);
                            commit("setSuccessMessage", successMessage);
                            dispatch("fetchFileContainerFromDatabase");
                        })
                        .catch((error) => {
                            commit("setLoading", false);
                            commit("setErrorMessage", error.message);
                        })
                })
                .catch((error) => {
                    commit("setLoading", false);
                    commit("setErrorMessage", error.message);
                })
        },
        deleteFile({ state, commit, dispatch }, payload) {
            commit("setLoading", true);
            const parentProps = help.getFolderProperties(state.folderStructure, state.activeFolder.id);
            const databasePath = parentProps.path + parentProps.id + "/files/" + payload.id;
            firebase.storage().ref(payload.storagePath).delete()
                .then(() => {
                    firebase.database().ref(databasePath).remove()
                        .then(() => {
                            commit("setLoading", false);
                            commit("setSuccessMessage", "File '" + payload.name + "." + payload.ext + "' successfully deleted.");
                            dispatch("refreshFilemanager");
                        })
                        .catch((error) => {
                            commit("setLoading", false);
                            commit("setErrorMessage", error.message);
                            dispatch("fetchFileContainerFromDatabase");
                        })
                })
                .catch((error) => {
                    commit("setLoading", false);
                    commit("setErrorMessage", error.message);
                })
        },
        downloadFile({ commit }, payload) {
            commit("setLoading", true);
            firebase.storage().ref(payload.storagePath).getDownloadURL()
                .then((url) => {
                    window.open(url, "_blank");
                    commit("setLoading", false);
                })
                .catch((error) => {
                    commit("setLoading", false);
                    commit("setErrorMessage", error.message);
                })
        },
        editFile({ commit, state, dispatch }, payload) {
            commit("setLoading", true);
            let fileProps = payload.props;
            let storagePath = "materials/";
            state.folderBreadCrumbs.forEach((item) => {
                if (item !== "") {
                    storagePath = storagePath + item + "/";
                }
            });
            let updatedFileProps = {
                name: payload.file.name.substr(0, payload.file.name.lastIndexOf('.')),
                ext: payload.file.name.substr(payload.file.name.lastIndexOf('.') + 1),
                type: fileProps.type,
                path: fileProps.path,
                createdBy: fileProps.createdBy,
                modifiedBy: payload.userId,
                createdDate: fileProps.createdDate,
                modifiedDate: new Date().toISOString(),
                level: fileProps.level,
                description: payload.description,
                version: fileProps.version + 1,
                displayName: fileProps.displayName,
                storagePath: storagePath + payload.file.name
            }
            firebase.storage().ref(fileProps.storagePath).delete()
                .then(() => {
                    firebase.storage().ref(updatedFileProps.storagePath).put(payload.file)
                        .then(() => {
                            firebase.database().ref(updatedFileProps.path + fileProps.id).update(updatedFileProps)
                                .then(() => {
                                    const successMessage = "The file was successfully edited.";
                                    commit("setLoading", false);
                                    commit("setSuccessMessage", successMessage);
                                })
                                .catch((error) => {
                                    commit("setLoading", false);
                                    commit("setErrorMessage", error.message);
                                    dispatch("fetchFileContainerFromDatabase");
                                })
                        })
                        .catch((error) => {
                            commit("setLoading", false);
                            commit("setErrorMessage", error.message);
                        })
                })
                .catch((error) => {
                    commit("setLoading", false);
                    commit("setErrorMessage", error.message);
                })
        }
    },
    modules: {}
}